import React from 'react';
import { Input } from '../../../Components/Form/Input';
import { ComponentArgs } from '../../../Components/EzForm';
import { AttributeDemographicMappingsInput } from '../../../graphQL';
import { Text } from '../../../globalStyles';

export const AttributeDemographicMappingHeaders = () => {
  return (
    <div className="w-100 flex items-center ml3">
      <div className="flex-auto mr2 pa3">
        <Text.bodyBold>Incoming Attribute</Text.bodyBold>
      </div>
      <div className="flex-auto mr2 pa3">
        <Text.bodyBold>Demographic Key</Text.bodyBold>
      </div>
      <div className="pa3 mr2" style={{ minWidth: '130px' }}>
        <Text.bodyBold>Update if Exists</Text.bodyBold>
      </div>
    </div>
  );
};

export const AttributeDemographicMappingInput = ({
  value,
  onChange,
  index,
}: ComponentArgs<AttributeDemographicMappingsInput>) => {
  return (
    <div className="w-100 flex items-center mb2">
      <Input
        value={value.attributeField}
        onChange={e => onChange({ ...value, attributeField: e.target.value })}
        placeholder={`Incoming Attribute #${index + 1}`}
        className="flex-auto pa3 mr2"
      />
      <Input
        value={value.demographicKey}
        onChange={e => onChange({ ...value, demographicKey: e.target.value })}
        placeholder={`Demographic Key #${index + 1}`}
        className="flex-auto pa3 mr2"
      />
      <div className="flex items-center tc pa3 mr2" style={{ minWidth: '130px' }}>
        <input
          type="checkbox"
          id={`updateIfExists-${index}`}
          checked={!!value.updateIfExists}
          onChange={e => onChange({ ...value, updateIfExists: e.target.checked })}
        />
      </div>
    </div>
  );
};
